import React from "react"

type Props = {
  className?: string
}

const LandingSectionUnderline: React.FC<Props> = ({ className = "" }) => (
  <div
    className={`mt-3 h-[3px] w-24 rounded-full bg-gradient-to-r from-dc-primary-900 via-[#9e7e43] to-transparent ${className}`.trim()}
    aria-hidden="true"
  />
)

export default LandingSectionUnderline
